/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hi",
  title2: " I'm Abdullah Al Mubin",
  logo_name: "Amt-Tawsik",
  // nickname: "harry / picleric",
  full_name: "Abdullah Al Mubin",
  subTitle1: "Software Engineer.",
  subTitle2: "Full Stack Developer.",
  subTitle3: "Life Long Learner.",
  subTitle: "Full Stack Developer, Software Engineer, Life Long Learner.",
  resumeLink:
    "https://drive.google.com/file/d/1Afu3NTnQL-zSXQdfvRbT6T3kITX66lYe/view?usp=sharing",
  mail: "mailto:amttawsik.cse@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/AmtTawsik",
  linkedin: "https://www.linkedin.com/in/abdullah-al-mubin-tawsik",
  gmail: "amttawsik.cse@gmail.com",
  twitter: "https://twitter.com/amttawsik22",
};

const skills = {
  data: [
    {
      _id: "354c54b7-ffd8-40f1-972f-1d006733df25",
      title: "Full-Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive user interfaces and backend for web applications",
        "⚡ Building responsive website front end using React, Vue, Next.js, and Nuxt.js",
        "⚡ Creating backend in Node, Express, MongoDB, Mongoose and Rest API",
        "⚡ Integration of third party services such as Firebase, MongoDB Realm, Vercel etc.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        // {
        //   skillName: "jQuery",
        //   fontAwesomeClassname: "simple-icons:jquery",
        //   style: {
        //     color: "#0769ad",
        //   },
        // },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "React Native",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#4BD88A",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#593D88",
          },
        },
        {
          skillName: "Vue",
          fontAwesomeClassname: "simple-icons:v",
          style: {
            color: "#8ED4C9",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "logos:nodejs",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "gray",
          },
        },
        {
          skillName: "Material UI",
          fontAwesomeClassname: "simple-icons:uikit",
          style: {
            color: "#007FFF",
          },
        },
        {
          skillName: "Tailwind CSS",
          fontAwesomeClassname: "logos:tailwindcss-icon",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "logos:nextjs",
          style: {
            color: "#8713FC",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Nuxt.js",
          fontAwesomeClassname: "logos:nuxt",
          style: {
            color: "#00dc82",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FF6C37",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "MongoDB Realm",
          fontAwesomeClassname: "logos:mongodb",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Stripe",
          fontAwesomeClassname: "logos:stripe",
          style: {
            color: "#635BFF",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "logos:c",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Mongoose",
          fontAwesomeClassname: "simple-icons:mongoose",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Ant Design",
          fontAwesomeClassname: "simple-icons:antdesign",
          style: {
            color: "#F7505E",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      _id: "c026fe64-1542-42b0-84ab-9311840c169f",
      title: "Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "Google Cloud Platform",
          fontAwesomeClassname: "skill-icons:gcp-dark",
          style: {
            backgroundColor: "transparent",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Vercel",
          fontAwesomeClassname: "skill-icons:vercel-light",
          style: {
            color: "gray",
            fill: "gray",
            // backgroundColor: "white",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
            width: "1em",
            height: "1em",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
            
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    // {
    //   title: "BUET",
    //   subtitle: "Masters in Computer Applications (MCA)",
    //   logo_path: "",
    //   alt_name: "BUET",
    //   duration: "2021 - 2023",
    //   descriptions: [
    //     "⚡ I have taken varity of courses related to Artificial Intelligence, Machine Learning, Computer Vision etc.",
    //     "⚡ Apart from this, I have done courses on Cloud Computing and Full Stack Development.",
    //   ],
    //   website_link: "https://www.amrita.edu/",
    // },
    {
      title: "Bangladesh Army University of Engineering & Technology, Natore.",
      subtitle: "Bachelors in Computer Science Engineering (BSc)",
      logo_path: "bauet-logo.png",
      alt_name: "BAUET",
      duration: "2018 - 2022",
      descriptions: [
        "⚡ Here, I studied a strong foundation in software engineering with in-depth knowledge of Data Structure, Algorithms, DBMS, Computer Networks, Computer Graphics, and more.",
        "⚡ I have successfully completed multiple projects in Web Development, Android Development, AI, Computer Graphics, and Computer Networking, showcasing my ability to apply my skills in diverse areas.",
        "⚡ Additionally, I have gained specialized expertise in advanced topics such as Machine Learning, Data Mining, DSP, and DIP, enabling me to tackle complex challenges in these specialized areas of software engineering and technology."
      ],
      website_link: "https://bauet.ac.bd/",
    },
    {
      title: "Nawab Siraj-Ud-Dowla Govt. College, Natore.",
      subtitle: "Higher Secondary School Certificate (HSC)",
      logo_path: "ns.png",
      alt_name: "NS",
      duration: "2016 - 2017",
      descriptions: [
        "⚡ I have studied basic Science subjects like Physics, Chemistry, Biology , Higher Math, Information & Technology, etc.",
        "⚡ I have also others subject like Bangla, English, Math , etc."
      ],
      website_link: "https://nsc.edu.bd/",
    },
    {
      title: "Natore Govt. Boys' High School",
      subtitle: "Secondary School Certificate (SSC)",
      logo_path: "ngbhs.jpeg",
      alt_name: "NGBHS",
      duration: "2015 - 2016",
      descriptions: [
        "⚡ I have studied basic Science subjects like Physics, Chemistry, Biology , Higher Math, Information & Technology, etc.",
        "⚡ I have also others subject like Bangla, English, Math , etc."
      ],
      website_link: "http://www.ngbhsnatore.edu.bd/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Next Level Web development (Level-2)",
      subtitle: "Programming Hero",
      logo_path: "ph-1.png",
      certificate_link:
        "https://drive.google.com/file/d/17sG0kV2VLawso18s5A4aiFVV1HgHlWWj/view?usp=sharing",
      alt_name: "Programming Hero",
      color_code: "#070623",
    },
    {
      title: "Complete Web Development",
      subtitle: "Programming Hero",
      logo_path: "ph-1.png",
      certificate_link:
        "https://drive.google.com/file/d/1xIFZPCmXt8jy1XMVmxcQgqb_g-oGrssZ/view?usp=sharing",
      alt_name: "Programming Hero",
      color_code: "#070623",
    },
    {
      title: "Black Belt Web Developer",
      subtitle: "Programming Hero",
      logo_path: "ph-2.png",
      certificate_link:
        "https://drive.google.com/file/d/1oC_0D3t-7pCRZ1dh27ga-KCDRiW49d9s/view?usp=sharing",
      alt_name: "Programming Hero",
      color_code: "#0A0A0A",
    },
    {
      title: "Web Design",
      subtitle: "10 Minute School",
      logo_path: "tms-1.png",
      certificate_link:
        "https://drive.google.com/file/d/1f0pDjaIjQYpo-owrE7UxatYLbNjLiRpT/view?usp=sharing",
      alt_name: "10 Minute School.",
      color_code: "#ffffff",
    },
    {
      title: "HTML5, CSS3 & Bootstrap For Web Development",
      subtitle: "Bohubrihi",
      logo_path: "bohubrihi.png",
      certificate_link:
        "https://drive.google.com/file/d/1sEEJdYIY3jaBkHTcsYBJL7JOQGU0nqbd/view?usp=sharing",
      alt_name: "Bohubrihi",
      color_code: "#1E1E1E",
    },
    {
      title: "Basics of Artificial Intelligence",
      subtitle: "10 Minute School",
      logo_path: "tms-1.png",
      certificate_link:
        "https://drive.google.com/file/d/1RhS40GFJchr4fbPuNyj0wLHNK2SRS83C/view?usp=drive_link",
      alt_name: "10 Minute School",
      color_code: "#ffffff",
    },
    {
      title: "Presentation & Public Speaking",
      subtitle: "10 Minute School",
      logo_path: "tms-2.png",
      certificate_link:
        "https://drive.google.com/file/d/1RhS40GFJchr4fbPuNyj0wLHNK2SRS83C/view?usp=drive_link",
      alt_name: "10 Minute School",
      color_code: "#181818",
    },
    {
      title: "Full Mark in All Assignment",
      subtitle: "Programming Hero",
      logo_path: "ph-3.jpeg",
      certificate_link:
        "https://drive.google.com/file/d/19qYTR-55__12oByApGgFbADikGFjjMn0/view?usp=drive_link",
      alt_name: "Programming Hero",
      color_code: "#110E2D",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Apprenticeship",
  description:
    "I have over 2 years of experience as a Full Stack Software Engineer, during which I have worked on projects for different Companies. In addition to my corporate work, I have also taken on personal projects, reflecting my entrepreneurial spirit and love for software development.",
  header_image_path: "experience.svg",
  sections: {
    title: "Work Experience",
    experiences: [
      {
        title: "Software Engineer",
        company: "Qualyval Consulting",
        company_url: "https://www.qualyval.com/",
        logo_path: "qualyval.jpg",
        alt_name: "Qualyval-logo",
        duration: "(Jul, 2022 - Present)",
        location: "London, England, UK (Remote)",
        description:
          "<li>I am fulfilling the responsibilities of a full-stack Software Engineer, proficiently working with technologies like Vue.js, Nuxt.js, Node.js, Express.js, MongoDB, and MongoDB Realm to develop and maintain multiple websites and ensure seamless user experiences.</li> <br><li>I take on additional challenges as a problem solver, addressing complex issues and troubleshooting technical problems within the company's projects, and showcase strong analytical and debugging skills.</li><br><li>I Exemplify adaptability by seamlessly shifting between development tasks and taking up problem-solving challenges while fostering effective collaboration with Full-Stack Software Engineering teams to deliver cutting-edge, high-quality solutions that drive the success of the company's software projects.</li>",
        color: "#ffffff",
      },
      {
        title: "Full-Stack Developer Intern",
        company: "Qualyval",
        company_url: "https://www.qualyval.com/",
        logo_path: "qualyval-2.jpg",
        alt_name: "Qualyval-logo",
        duration: "(Dec, 2022 - Jun, 2023)",
        location: "London, England, UK (Remote)",
        description:
          "<li>I Developed multiple websites using React, Vue, and Nuxt, showcasing expertise in frontend technologies and creating intuitive user interfaces.</li><br><li>Leveraged MongoDB and MongoDB Realm for backend development. I have also implemented robust APIs for seamless data communication.</li><br><li>I Contributed to bug fixing and maintenance of existing websites and enhancing overall performance and ensuring high-quality web applications.</li>",
        color: "#ffffff",
      },
      {
        title: "Junior Full Stack Developer Trainee",
        company: "Brain Station 23.",
        company_url: "https://brainstation-23.com/",
        logo_path: "BS.svg",
        alt_name: "BS",
        duration: "(Nov, 2021 - Dec, 2021)",
        location: "Dhaka, Bangladesh. (Remote)",
        description:
          "<li>Worked on multiple projects using Python and Django.</li>",
        color: "#ffffff",
      },
    ],
  },
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "In my projects, I use a wide range of the latest technology tools. My best experience comes from creating projects using the MERN (MongoDB, Express.js, React, Node.js) and MEVN (MongoDB, Express.js, Vue.js, Node.js) stacks. Some of my projects include an e-commerce website, a Drawing application, a Photography related app, a Course Selling App, a Hiring management system, etc.",
  avatar_image_path: "projects_image.svg",
};

const blogsHeader = {
  title: "Blogs",
  description:
    "Explore my insights, experiences, and tutorials on the latest web development trends and technologies. My blog covers in-depth guides on modern frameworks, real-world project case studies, and showcases my latest gigs, where I offer professional web development services.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      id: "project-0",
      name: "Nest-Shapers",
      url: "https://nest-shapers-front-end.vercel.app",
      repoUrl: "https://github.com/AmtTawsik/Nest-Shapers-Front-End",
      description:
        "The fully responsive MERN stack home services website boasts a seamless user experience with its user-friendly sign-up and sign-in process. Users navigate a step-by-step service booking system, ensuring clear confirmation at every stage. The platform offers distinct interfaces tailored for users, customers, admin, and super-admin, facilitating efficient management and access control. Extensive CRUD operations are integrated throughout the system, empowering users with comprehensive control over their interactions and data management.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Next",
          iconifyClass: "logos:nextjs",
        },
        {
          name: "ExpressJs",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Mongoose",
          iconifyClass: "vscode-icons:file-type-mongoose",
        },
        {
          name: 'AntDesign',
          iconifyClass: ''
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
      ],
    },
    {
      id: "project-1",
      name: "Horses-of-Past",
      url: "https://horses-of-past.web.app/",
      repoUrl: "https://github.com/AmtTawsik/Horses-of-Past",
      description:
        "Horses-of-Past is a website for reselling old bikes with secure payment options. It features a homepage, FAQ section, and programming-related blogs. The Dashboard offers routes for Admin, Buyer, and Seller roles, with email and Google account logins for users.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "ExpressJs",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Stripe",
          iconifyClass: "logos:stripe",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
        {
          name: "Firebase",
          iconifyClass: "logos:firebase",
        },
      ],
    },
    {
      id: "project-2",
      name: "PHOTO-PHACTORY",
      url: "https://photo-phactory-amt.web.app/",
      repoUrl: "https://github.com/AmtTawsik/photo-phactory",
      description:
        "The website 'PHOTO-PHACTORY' offers professional Photography services and allows users to rate them. It features a homepage providing essential information, along with a FAQ section to address common queries. A blog page offers programming-related content for users' interest.Additionally, the Services page showcases various Photography services and allows users to rate their experiences. User authentication is implemented, enabling login through email and password, as well as via Google accounts, ensuring a secure and personalized experience.",
        languages: [
          {
            name: "React",
            iconifyClass: "logos:react",
          },
          {
            name: "ExpressJs",
            iconifyClass: "simple-icons:express",
          },
          {
            name: "NodeJs",
            iconifyClass: "logos:nodejs",
          },
          {
            name: "MongoDB",
            iconifyClass: "vscode-icons:file-type-mongo",
          },
          {
            name: "Tailwind CSS",
            iconifyClass: "vscode-icons:file-type-tailwind",
          },
          {
            name: "Firebase",
            iconifyClass: "logos:firebase",
          },
        ],
    },
    {
      id: "project-3",
      name: "AMT-Build",
      url: "https://buils-amt-next.vercel.app/",
      repoUrl: "https://github.com/AmtTawsik/PC-Builder-With-Next.js",
      description:
        "PC Builder Website: This website offers a user-friendly PC Builder tool enabling users to customize their own PCs by adding selected components. The navbar features a 'PC Builder' button and a 'Categories' dropdown with various component options. The home page showcases 6 random PC components as Featured Products with essential details, and each component has a dedicated product detail page. Users can click on featured category sections to explore products from specific categories. The 'Add To Builder' button allows users to add components to their PC builds, and the 'Complete Build' button becomes active after adding at least 5-6 components. For enhanced security, user authentication is implemented using NextAuth with social login providers like Google or Github, making the PC Builder page accessible only to logged-in users.",
      languages: [
        {
          name: "Next",
          iconifyClass: "logos:nextjs",
        },
        {
          name: "Redux",
          iconifyClass: "simple-icons:redux",
        },
        {
          name: "Nodejs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
        {
          name: "Ant Design",
          iconifyClass: "simple-icons:antdesign",
        },
      ],
    },
    {
      id: "project-4",
      name: "Skill Online",
      url: "https://skill-online.web.app/",
      repoUrl: "https://github.com/AmtTawsik/skill-online",
      description: "Skill Online: This website offers a comprehensive skill and quality learning platform. It features a homepage providing essential information about the platform. The FAQ page offers answers to common queries, while the blog page presents programming-related blogs for users' benefit. Additionally, the website includes a course page with a selection of courses available for purchase. Users can log in using their email and password, or through their Google and GitHub accounts for added convenience and security.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "ExpressJs",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
        {
          name: "Firebase",
          iconifyClass: "logos:firebase",
        },
      ],
    },
    // {
    //   id: "project-4",
    //   name: "Quizzer",
    //   url: "https://quizzzer-amt.netlify.app/",
    //   repoUrl: "https://github.com/AmtTawsik/Quizzer",
    //   description: "I have created a Quiz application using React with React Router and Tailwind CSS. The app uses an API to fetch quiz questions. The application consists of a Home Page, Statistic page, and Blog Page. Users can participate in the quiz and track their scores. The NavBar and Footer are enhanced with FloatUI. The Statistic page features a Chart created using Rechart, displaying user quiz performance. The application offers an interactive and engaging experience for users to test their knowledge through quizzes and view their progress on the Statistic page.",
    //   languages: [
    //     {
    //       name: "React",
    //       iconifyClass: "logos:react",
    //     },
    //     {
    //       name: "Tailwind CSS",
    //       iconifyClass: "vscode-icons:file-type-tailwind",
    //     },
    //     {
    //       name: "MongoDB",
    //       iconifyClass: "vscode-icons:file-type-mongo",
    //     },
    //   ],
    // },
    {
      id: "project-5",
      name: "Hiring-Management",
      url: "https://hiring-management-amt.netlify.app",
      repoUrl: "",
      description:
        "The 'Hire-management' is a feature-rich application designed to streamline the hiring process for companies. It offers essential functionalities such as job posting and application submission, enabling companies to efficiently receive and manage job applications from candidates",
      languages: [
        {
          name: "Next js",
          iconifyClass: "logos:nuxt",
        },
        {
          name: "vue",
          iconifyClass: "logos:vue",
        },
        {
          name: "MongoDB Realm",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Tailwind",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
        {
          name: "Folw Bite",
          iconifyClass: "simple-icons:tailwindcss",
        },
      ],
    },
  ],
};

const blogs = {
  data: [
    {
      id: "0",
      name: "Stunning Full-Stack Web Apps with React, Vue, Node, and More!",
      blogLink: "https://dev.to/amttawsik/stunning-full-stack-web-apps-with-react-vue-node-and-more-gkf",
      imgUrl: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fv13kyy9vrfja9a9q7sdh.png",
      description:
        "In today's digital world, having a high-performance and visually stunning web application is crucial for businesses and entrepreneurs. Whether you need a cutting-edge e-commerce platform, a powerful dashboard, or a custom-built application, I can help bring your vision to life. As a professional full-stack web developer, I specialize in crafting modern, responsive, and scalable web apps using the latest technologies.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Next",
          iconifyClass: "logos:nextjs",
        },
        {
          name: "ExpressJs",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Mongoose",
          iconifyClass: "vscode-icons:file-type-mongoose",
        },
        {
          name: 'AntDesign',
          iconifyClass: ''
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
      ],
    },
    {
      id: "1",
      name: "Figma to React Next.js with Tailwind, MUI, and Ant Design!",
      blogLink: "https://dev.to/amttawsik/figma-to-react-nextjs-with-tailwind-mui-and-ant-design-3k5n",
      imgUrl: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fa9g6k4rk5e8le2lgd949.jpg",
      description:
        "Are you looking for a pixel-perfect, responsive, and high-performance React Next.js website from your Figma design? You've come to the right place!",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Next",
          iconifyClass: "logos:nextjs",
        },
        {
          name: "ExpressJs",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Mongoose",
          iconifyClass: "vscode-icons:file-type-mongoose",
        },
        {
          name: 'AntDesign',
          iconifyClass: ''
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
      ],
    },
    {
      id: "2",
      name: "Pixel-Perfect Figma to Vue 3 & Nuxt 3: Tailwind CSS Integration!",
      blogLink: "https://dev.to/amttawsik/pixel-perfect-figma-to-vue-3-nuxt-3-tailwind-css-integration-5blo",
      imgUrl: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fsm5rvggcjb5hulshn20v.png",
      description:
        "Are you looking for a seamless transition from Figma to a fully functional, high-performance web interface? As an expert front-end developer, I specialize in converting Figma designs into pixel-perfect, responsive websites using Vue 3, Nuxt 3, and Tailwind CSS.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos:react",
        },
        {
          name: "Next",
          iconifyClass: "logos:nextjs",
        },
        {
          name: "ExpressJs",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "NodeJs",
          iconifyClass: "logos:nodejs",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Mongoose",
          iconifyClass: "vscode-icons:file-type-mongoose",
        },
        {
          name: 'AntDesign',
          iconifyClass: ''
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
      ],
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "portfolioProfileImage.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
  blogs,
  blogsHeader
};
